import { render, staticRenderFns } from "./batchCollectionRecordDetailOnline.vue?vue&type=template&id=b8d519ac&scoped=true"
import script from "./batchCollectionRecordDetailOnline.vue?vue&type=script&lang=js"
export * from "./batchCollectionRecordDetailOnline.vue?vue&type=script&lang=js"
import style0 from "./batchCollectionRecordDetailOnline.vue?vue&type=style&index=0&id=b8d519ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d519ac",
  null
  
)

export default component.exports